Vendd.Scripts.load(function () {
  const sliderContainer = document.getElementById("homepage-promo-banner-slides");
  if (!sliderContainer) return;

  const sliderElement = sliderContainer.querySelector(".x-swiper-slider");
  if (!sliderElement || !sliderElement.swiper) return;

  const videoWrappers = sliderElement.querySelectorAll(".video-wrapper[data-vimeo-url]");
  if (videoWrappers.length === 0) return;

  const swiper = sliderElement.swiper;
  const speed = swiper.params.speed || 0;

  // a video on the first slide holds the autoplay until the video actually starts playing
  let waitingForVideo = false;
  const firstSlide = swiper.slides[swiper.activeIndex];

  if (firstSlide && firstSlide.querySelector(".video-wrapper[data-vimeo-url]") && swiper.autoplay && swiper.autoplay.running) {
    waitingForVideo = true;
    swiper.autoplay.stop();
    swiper.on("autoplayStart", function () {
      waitingForVideo = false;
    });
  }

  if (!window.Vimeo || !window.Vimeo.Player) {
    window.addEventListener("load", function () {
      if (window.Vimeo && window.Vimeo.Player) initVideoSlides();
      else startWaitingAutoplay();
    });
    return;
  }

  initVideoSlides();

  function initVideoSlides() {
    const videoSlides = [];

    videoWrappers.forEach(function (wrapper) {
      const url = wrapper.getAttribute("data-vimeo-url");
      const slide = wrapper.closest(".swiper-slide");
      if (!url || !slide) return;

      const player = new Vimeo.Player(wrapper, {
        url: url,
        autoplay: true,
        muted: true,
        loop: true,
        controls: false,
        autopause: false,
        playsinline: true,
      });

      videoSlides.push({ slide: slide, player: player });

      if (waitingForVideo && slide === firstSlide) {
        player.on("playing", function onFirstPlaying() {
          player.off("playing", onFirstPlaying);
          player
            .getDuration()
            .then(function (duration) {
              const durationMs = Math.round(duration * 1000);
              if (durationMs) slide.setAttribute("data-video-duration", durationMs);
            })
            .catch(function () {})
            .then(startWaitingAutoplay);
        });
      }

      player
        .ready()
        .then(function () {
          if (!isActive(slide)) pause(player);

          Promise.all([player.getVideoWidth(), player.getVideoHeight()])
            .then(function (size) {
              if (size[0] && size[1]) coverWrapper(wrapper, size[0] / size[1]);
            })
            .catch(function () {});

          return player.getDuration();
        })
        .then(function (duration) {
          const durationMs = Math.round(duration * 1000);
          if (!durationMs) return;

          slide.setAttribute("data-video-duration", durationMs);
          // the autoplay timer starts after the transition ends while the video starts with it
          slide.setAttribute("data-swiper-autoplay", Math.max(durationMs - speed, 1000));
        })
        .catch(function (error) {
          console.log("vimeo player error ", error);
          if (slide === firstSlide) startWaitingAutoplay();
        });
    });

    if (videoSlides.length === 0) return;

    swiper.on("slideChangeTransitionStart", function () {
      // user moved away from the first slide before its video started: don't keep holding the autoplay
      if (waitingForVideo) startWaitingAutoplay();

      // navigating always resumes the slideshow (swiperSliders.js), so the incoming video plays
      videoSlides.forEach(function (videoSlide) {
        if (isActive(videoSlide.slide)) {
          playFromStart(videoSlide.player);
        } else {
          pause(videoSlide.player);
        }
      });
    });

    // thumbs pause/play button (handled in swiperSliders.js): capture phase runs before its autoplay stop/start
    sliderContainer.addEventListener(
      "click",
      function (event) {
        const control = event.target.closest(".thumb-autoplay");
        if (!control) return;

        const activeVideo = videoSlides.find(function (videoSlide) {
          return isActive(videoSlide.slide);
        });
        if (!activeVideo) return;

        // swiperSliders.js keeps the ring progress and the remaining autoplay time, the video just pauses/continues
        if (!control.classList.contains("is-paused")) {
          pause(activeVideo.player);
        } else {
          activeVideo.player.play().catch(function (error) {
            console.log("vimeo play error ", error);
          });
        }
      },
      true
    );

    // play is not chained after the seek: setCurrentTime never resolves on a video that has not played yet
    function playFromStart(player) {
      player.play().catch(function (error) {
        console.log("vimeo play error ", error);
      });

      player
        .getCurrentTime()
        .then(function (seconds) {
          if (seconds > 0) return player.setCurrentTime(0);
        })
        .catch(function (error) {
          console.log("vimeo seek error ", error);
        });
    }

    function pause(player) {
      player.pause().catch(function (error) {
        console.log("vimeo pause error ", error);
      });
    }
  }

  // iframes ignore object-fit: size the iframe to the video ratio so it covers the wrapper, the overflow is cropped (Home.less)
  function coverWrapper(wrapper, ratio) {
    const iframe = wrapper.querySelector("iframe");
    if (!iframe) return;

    const resize = function () {
      const width = wrapper.clientWidth;
      const height = wrapper.clientHeight;
      if (!width || !height) return;

      const coverWidth = Math.max(width, height * ratio);
      iframe.style.width = Math.ceil(coverWidth) + "px";
      iframe.style.height = Math.ceil(coverWidth / ratio) + "px";
    };

    resize();

    if (window.ResizeObserver) new ResizeObserver(resize).observe(wrapper);
    else window.addEventListener("resize", resize);
  }

  function isActive(slide) {
    return swiper.slides[swiper.activeIndex] === slide;
  }

  function startWaitingAutoplay() {
    if (!waitingForVideo) return;
    waitingForVideo = false;

    // first slide has no incoming transition, so the timer must cover the whole video
    const reducedDelay = firstSlide.getAttribute("data-swiper-autoplay");
    const durationMs = firstSlide.getAttribute("data-video-duration");
    if (durationMs) firstSlide.setAttribute("data-swiper-autoplay", durationMs);

    swiper.autoplay.start();

    if (reducedDelay) firstSlide.setAttribute("data-swiper-autoplay", reducedDelay);
  }
});
